import { Type } from '@angular/core';
import { Button } from '@shared/abstraction/button/button';
import { DrawerBody } from '@shared/abstraction/drawer/drawer-body';
import { Subject } from 'rxjs';
import { Drawer } from '@shared/abstraction/drawer/drawer';

export class DrawerSetting<ToBody, FromBody> implements Drawer {
  title!: string;
  primaryButton!: Button;
  secondaryButton?: Button;
  component!: Type<DrawerBody>;
  hideCloseButton?: boolean;
  hideFooterButtons?: boolean;
  mask?: boolean;
  data?: ToBody;

  private dataFromBody: Subject<FromBody> = new Subject<FromBody>();

  readonly close: Subject<void> = new Subject<void>();
  readonly primaryHandler: Subject<void> = new Subject<void>();
  readonly secondaryHandler: Subject<void> = new Subject<void>();

  fromBody<T>(): Subject<T> {
    return this.dataFromBody as unknown as Subject<T>;
  }

  toBody<T>(): T {
    return this.data as unknown as T;
  }
}
